import { QueryCache, QueryClient } from '@tanstack/react-query'
import { HTTPError } from 'ky'
import { toast } from 'sonner'

export const queryClient = new QueryClient({
  queryCache: new QueryCache({
    onError: (error) => {
      if (error instanceof HTTPError) {
        if (error.response.status >= 500) {
          toast.error('Erreur serveur. Réessayez plus tard.')
        }
        // 4xx : géré par chaque page (état vide, redirect 401 via api.ts)
      } else {
        toast.error('Erreur réseau. Vérifiez votre connexion.')
      }
    },
  }),
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 2, // 2 min
      gcTime: 1000 * 60 * 10, // 10 min
      retry: 1,
      refetchOnWindowFocus: false,
    },
    mutations: {
      retry: 0,
    },
  },
})
